import { render, staticRenderFns } from "./msElegant.vue?vue&type=template&id=32020f0c&scoped=true"
import script from "./msElegant.vue?vue&type=script&lang=js"
export * from "./msElegant.vue?vue&type=script&lang=js"
import style0 from "./msElegant.vue?vue&type=style&index=0&id=32020f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32020f0c",
  null
  
)

export default component.exports